<svg viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg">
    <title/>
    <g data-name="6-Photo" id="_6-Photo">
        <path d="M43,0H5A5,5,0,0,0,0,5V43a5,5,0,0,0,5,5H43a5,5,0,0,0,5-5V5A5,5,0,0,0,43,0ZM5,46a3,3,0,0,1-3-3V40.46l16-16L39.59,46Zm41-3a3,3,0,0,1-3,3h-.59L28.55,32.14l7.59-7.59L46,34.41Zm0-11.41-9.16-9.16a1,1,0,0,0-1.41,0l-8.29,8.29-8.41-8.41a1,1,0,0,0-1.41,0L2,37.63V5A3,3,0,0,1,5,2H43a3,3,0,0,1,3,3Z"/>
        <path d="M25,7a6,6,0,1,0,6,6A6,6,0,0,0,25,7Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,25,17Z"/>
    </g>
</svg>